import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { MdLogout, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { AiOutlineNotification } from "react-icons/ai";
import { PiUserCircleDuotone } from 'react-icons/pi';
import axios from 'config/axios';
import { getAuth, signOut } from 'firebase/auth';
import firebaseApp from 'config/firebase';
import { useAuthContext } from 'context/AuthContext';

import './index.css';

type HeaderProps = {
    title?: string;
    prevRoutes?: {
        name: string;
        path: string;
    }[];
};

function Header({ title, prevRoutes }: HeaderProps) {
    const auth = getAuth(firebaseApp);
    const { user, setUser } = useAuthContext();

    const handleAlert = () => {
        axios.post('tutors/alert/')
            .then(res => {
                setUser({
                    ...user,
                    alert: false
                });
            })
            .catch(error => {
            console.log(error);
        });
    }

    return (
        <div className='header'>
            <div className='header__header'>
                {prevRoutes?.map(route => (
                    <React.Fragment key={route.path}>
                        <Link className='header__prevRoute' to={route.path}>
                            {route.name}
                        </Link>
                        <MdOutlineKeyboardArrowRight className='header__arrow' />
                    </React.Fragment>
                ))}
                {title && <h1 className='header__title'>{title}</h1>}
            </div>
            {user &&
                <div className='header__account'>
                    <a 
                        className='header__notButton' 
                        href='https://www.notion.so/The-SAT-Crash-Course-New-Updates-2a85462623438082a2e9cbe9856547dd'
                        target='_blank'
                        onClick={handleAlert}
                    >
                        <AiOutlineNotification className='header__accountNot'/>
                        {user.alert && <div className='header__notSign'>𒊹</div>}
                    </a>
                    {/* <div className='header__credits'>
                        <p>Remaining Credits <b className=''>100</b></p>
                    </div> */}
                    <Link className='header__accountButton' to='/profile'>
                        <PiUserCircleDuotone className='header__accountAvatar' />
                        {user.firstName} {user.lastName}
                    </Link>
                    <button className='header__logout' onClick={() => signOut(auth)}>
                        Logout
                        <MdLogout className='header__logoutIcon' />
                    </button>
                </div>
            }
        </div>
    );
}

export default Header;